import { KrokStep } from "src/app/form-v2/form-model/StepKrok";


export class ModulMulti {
    moduleNg:KrokStep;
    pozycje:KrokStep[] = [];
    moduleFooter:KrokStep;
    poprawne:boolean = true;


    constructor(){
    }
    
    
}